module.exports = __webpack_public_path__ + "img/II-43.2.0d8e83b1.svg";